module.exports = " <div class=team _v-28676324=\"\"> <header-group :heading=team.name :heading2=team.type_label subheading=\"Oversigt over holdet\" _v-28676324=\"\"></header-group> <p class=text _v-28676324=\"\">{{{team.description}}}</p> <ul _v-28676324=\"\"> <list-item v-for=\"item in items\" size=small :index=$index v-link=item.link _v-28676324=\"\"> {{item.title}} </list-item> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-28676324!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/Team.vue
// module id = 738
// module chunks = 2